export const APP_VERSION = '1.27.1-73';
